<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>
<page-content>
  <div class="sub-header">
    <div class="title">Link</div>
    <div class="state">Image</div>
    <div class="drag">
      <mat-icon>keyboard_arrow_up</mat-icon>
      <mat-icon>keyboard_arrow_down</mat-icon>
    </div>
    <div class="actions"></div>
  </div>

  <div *ngIf="!!banners?.length" cdkDropList [cdkDropListData]="banners" class="list" (cdkDropListDropped)="drop($event)">
    <ng-container *ngFor="let item of banners">
      <div class="item" cdkDrag cdkDragBoundary=".list" (click)="edit(item)">
        <div class="drag-placeholder" *cdkDragPlaceholder></div>
        <div class="title">{{item.link}}</div>
        <div class="state">{{item.image}}</div>
        <div class="drag" cdkDragHandle matTooltip="{{'packages.installedApps.dragTip'| translate}}"><mat-icon>drag_indicator</mat-icon></div>
        <div class="actions">
          <button (click)="edit(item)" [matTooltip]="'packages.navigation.editMenupoint' | translate"><mat-icon>edit</mat-icon></button>
        </div>
      </div>
    </ng-container>
  </div>
</page-content>
